import React from 'react';
import { Modal } from 'reaxl';
import GenericVideoPlayer from './GenericVideoPlayer';

const renderVideoModal = (video, ctaOptions, autoStart = false, originPage) => (
    <Modal
        className="generic-video-modal"
        bsSize="lg"
        trapFocus
    >
        <Modal.Header closeButton />
        <Modal.Body>
            <GenericVideoPlayer
                video={video}
                ctaOptions={ctaOptions}
                playsinline={false}
                allowfullscreen
                autostart={autoStart}
                originPage={originPage}
            />
        </Modal.Body>
    </Modal>
);
export default renderVideoModal;
